import React, { useCallback, useState } from "react"
import { FaRegCopy } from "react-icons/fa6"
import { FiShare } from "react-icons/fi"
import _get from "lodash/get"
import _isEmpty from "lodash/isEmpty"
import useRazorpay from "react-razorpay"
import {
  calculateBookingAnounts,
  canBookingBeCancelled,
  canBookingBeRated,
  getCalndarInviteURLForGoogle,
  getCalndarInviteURLForOutlook,
  getDeskBookingChargesFromBooking,
  getFormattedStartDateTime,
  getGoogleMapsLink,
  getMeetingRoomChargesFromBooking,
  getSpaceBookingDuration,
  getSpaceDetails,
  isAwfisBooking,
  isAwfisDeskBooking,
  isBookingActiveFuture,
  isBookingConfirmed,
  isCancelBeforePrevDayMidnight,
  isOfficeSpace,
  isWeWorkBooking,
} from "../utils/common"
import Separator from "./Separator"
import { COLORS } from "../constants/colors"
import IconLabel from "./IconLabel"
import BookingTimeline from "./BookingTimeline"
import {
  cancelBooking,
  createRazorpayOrder,
  redeemToConfrimBooking,
  updatePaymentStatus,
} from "../api/common"
import Loader from "./Loader"
import RateExperience from "./RateExperience"

const BookingCard = ({ bookingInfo, user }) => {
  const {
    bookingid,
    bookingkey,
    spaceName,
    spaceaddress,
    startTime,
    status,
    spacecoords,
    gofloatersSpaceName,
    originalName,
    spaceDisplayName,
    headCount,
    spaceId,
    customerName,
  } = bookingInfo

  console.log({ bookingInfo })
  const [showEmailSelection, setShowEmailSelection] = useState(false)
  const [
    bookingCancellationInProgress,
    setBookingCancellationInProgress,
  ] = useState(false)
  const [paymentInProgress, setPaymanetInProgress] = useState(false)
  const [showRateExperience, setShowRateExperience] = useState(false)
  const [Razorpay] = useRazorpay()

  const onCancelBooking = useCallback(
    async e => {
      setBookingCancellationInProgress(true)
      const response = await cancelBooking(bookingkey)
      if (!_isEmpty(response)) {
        console.log("Booking has been cancelled successfully.")
        // toast.show('Booking has been cancelled successfully.');
        alert(
          `Your booking for ${gofloatersSpaceName} has been cancelled successfully.`
        )
      } else {
        console.log("Error cancelling booking. Please try again.")
        // toast.show('Error cancelling booking. Please try again.');
        alert("Error cancelling booking. Please try again.")
      }
      setBookingCancellationInProgress(false)
    },
    [bookingid]
  )

  const openRazorpayForPayment = useCallback(
    async (orderId, booking, priceToPay) => {
      const totalPayableAmount = _get(priceToPay, "totalPrice")
      console.log({ priceToPay, totalPayableAmount })
      const options = {
        key: "rzp_live_L4jnEFvzps4krf",
        amount: totalPayableAmount * 100,
        currency: "INR",
        name: "Gofloaters",
        description: "Payment for the space booking",
        image: "https://assets.gofloaters.com/logo.png",
        order_id: orderId,
        handler: async res => {
          const updatePaymentResponse = await updatePaymentStatus({
            paymentRefNumber: _get(res, "razorpay_payment_id"),
            uid: _get(user, "uid"),
            spaceType: _get(bookingInfo, "spaceType"),
            spaceUsageFee: _get(priceToPay, "spaceUsageFee"),
            gstFee: _get(priceToPay, "gst"),
            redeemedPoints: _get(user, "floatingpoints"),
            id: _get(booking, "bookingkey"),
          })
          alert("Payment done successfully.")
          // setBookingDetails(booking)
        },
        prefill: {
          name: _get(user, "displayName"),
          email: _get(user, "email"),
          contact: _get(user, "phoneNumber"),
        },
        notes: {
          address: "Gofloaters",
        },
        theme: {
          color: "#2798B5",
        },
      }

      const rzpay = new Razorpay(options)
      rzpay.on("payment.failed", function (response) {
        alert(response.error.description)
        console.log({ response })
      })

      rzpay.open()
    },
    [Razorpay, user, bookingInfo]
  )

  const onRedeemToConfirmPress = async () => {
    setPaymanetInProgress(true)
    // let price = getMeetingRoomChargesFromBooking(bookingInfo, user)
    // if (isOfficeSpace(bookingInfo)) {
    //   price = getDeskBookingChargesFromBooking(bookingInfo, user)
    // }
    const price = calculateBookingAnounts(user, bookingInfo, [bookingInfo])
    // const { totalPrice } = getDeskBookingChargesFromBooking(bookingInfo, user)

    // if(_get(bookingInfo, ''))
    const { totalPrice, breakup } = price
    console.log({ price, totalPrice, breakup })
    if (totalPrice > 0) {
      try {
        const razorpayResponse = await createRazorpayOrder(
          _get(bookingInfo, "bookingkey")
        )
        const razorpayPaymentDetails = await openRazorpayForPayment(
          _get(razorpayResponse, "orderId"),
          bookingInfo,
          price
        )
      } catch {
        alert("Error paying for booking. please try again")
      }
    } else {
      try {
        const response = await redeemToConfrimBooking(bookingInfo, user)
        if (!_isEmpty(response)) {
          console.log("Credits redeemed successfully.")
          alert("Credits redeemed successfully.")
          // toast.show('Credits redeemed successfully.');
        }
      } catch (error) {
        console.log(error)
      }
    }
    setPaymanetInProgress(false)
  }

  const onClickOpenMaps = useCallback(() => {
    if (_get(bookingInfo, "googleMapsLink")) {
      window.open(_get(bookingInfo, "googleMapsLink"), "_blank")
    } else {
      window.open(getGoogleMapsLink(spacecoords), "_blank")
      // Linking.openURL(getGoogleMapsLink(spacecoords));
    }
  }, [spacecoords])

  const onGoogleCalendarClick = () => {
    window.open(getCalndarInviteURLForGoogle(bookingInfo), "_blank")
  }

  const onOutlookCalendarClick = () => {
    window.open(getCalndarInviteURLForOutlook(bookingInfo), "_blank")
  }

  const showEmailClientSelection = () => setShowEmailSelection(true)
  const hideEmailClientSelection = () => setShowEmailSelection(false)

  const showRateExperienceModal = () => setShowRateExperience(true)
  const hideRateExperienceModal = () => setShowRateExperience(false)

  return (
    <div className="col-md-4" style={{ padding: 8 }}>
      <div
        style={{
          border: "1px solid #F1F0F3",
          borderRadius: 12,
          marginBottom: 16,
          padding: "16px 0",
        }}
      >
        <div
          style={{
            padding: "0 16px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <p
              className="bold mb-0"
              style={{ color: "#2798B5", marginBottom: 8 }}
            >
              Booking ID: {bookingid}
            </p>
            <p className="mb-0">
              {isOfficeSpace(bookingInfo)
                ? `${headCount}x Individual Desks`
                : `${headCount} Seater Meeting Room`}
            </p>
          </div>
        </div>

        <Separator />
        <div style={{ padding: "0 16px" }}>
          <BookingTimeline status={status} />
        </div>

        <div style={{ padding: "0 16px", marginTop: 16 }}>
          <p className="mb-0 bold" style={{ fontSize: "0.8rem" }}>
            {gofloatersSpaceName} - {originalName}
          </p>
          <p className="mb-0" style={{ fontSize: "0.7rem", color: "#2798B5" }}>
            {spaceDisplayName}
          </p>
          <p className="mb-0" style={{ fontSize: "0.7rem" }}>
            {getSpaceDetails(spaceaddress)}
          </p>
        </div>

        <div
          className="d-flex justify-content-between align-items-center"
          style={{ padding: "0 16px", marginTop: 16 }}
        >
          <p
            className="mb-0 bold"
            style={{
              color: COLORS.BUTTON_COLORS.SECONDARY_COLOR,
              fontSize: "0.7rem",
            }}
            onClick={showEmailClientSelection}
          >
            Add to Calendar {">"}
          </p>
          <p
            onClick={onClickOpenMaps}
            className="mb-0 bold"
            style={{
              color: COLORS.BUTTON_COLORS.SECONDARY_COLOR,
              fontSize: "0.7rem",
              cursor: "pointer",
            }}
          >
            Open in Maps {">"}
          </p>
        </div>

        <div style={{ padding: "0 16px", marginTop: 16 }}>
          <p
            style={{ color: COLORS.TEXT_COLOR_SECONDARY, fontSize: "0.7rem" }}
            className="mb-0"
          >
            {getFormattedStartDateTime(startTime, "DD MMM, YYYY")} <br />
            From {getFormattedStartDateTime(startTime, "hh:mm a")} <br />
            For {getSpaceBookingDuration(bookingInfo)} hours
          </p>
        </div>

        {isWeWorkBooking(bookingInfo) ? (
          <div style={{ padding: " 16px 16px 0" }}>
            <p
              className="mb-0"
              style={{ color: COLORS.TEXT_COLOR_SECONDARY, fontSize: "0.7rem" }}
            >
              WeWork Order: {_get(bookingInfo, "wework.orderNumber")}
            </p>
            <p
              className="mb-0"
              style={{ color: COLORS.TEXT_COLOR_SECONDARY, fontSize: "0.7rem" }}
            >
              WeWork Status: {_get(bookingInfo, "wework.orderStatus")}
            </p>
          </div>
        ) : null}

        {isAwfisBooking(bookingInfo) ? (
          <div style={{ padding: " 16px 16px 0" }}>
            <p
              className="mb-0"
              style={{ color: COLORS.TEXT_COLOR_SECONDARY, fontSize: "0.7rem" }}
            >
              AWFIS Order: {_get(bookingInfo, "awfis.orderNumber")}
            </p>
            <p
              className="mb-0"
              style={{ color: COLORS.TEXT_COLOR_SECONDARY, fontSize: "0.7rem" }}
            >
              AWFIS Status: {_get(bookingInfo, "awfis.orderStatus")}
            </p>
          </div>
        ) : null}

        <div
          style={{
            padding: 16,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {isBookingConfirmed(bookingInfo) ? (
            !paymentInProgress ? (
              <IconLabel
                label={"Pay / Redeem to Confirm"}
                icon={"fa fa-money"}
                onClick={onRedeemToConfirmPress}
                style={{ cursor: "pointer" }}
                iconContainer={{ width: 28, height: 28 }}
                labelStyle={{
                  fontSize: "0.8rem",
                  color: COLORS.TEXT_COLOR_SECONDARY,
                }}
              />
            ) : (
              <Loader style={{ width: 16, height: 16 }} />
            )
          ) : null}

          {canBookingBeRated(bookingInfo) ? (
            <IconLabel
              label={"Rate Experience"}
              icon={"fa fa-commenting-o"}
              onClick={showRateExperienceModal}
              style={{ cursor: "pointer" }}
              iconContainer={{ width: 28, height: 28 }}
              labelStyle={{
                fontSize: "0.8rem",
                color: COLORS.TEXT_COLOR_SECONDARY,
              }}
            />
          ) : null}

          {canBookingBeCancelled(bookingInfo) ||
          (isBookingActiveFuture(bookingInfo) &&
            (isWeWorkBooking(bookingInfo) ||
              isAwfisDeskBooking(bookingInfo))) ||
          (isCancelBeforePrevDayMidnight(bookingInfo) &&
            isAwfisBooking(bookingInfo)) ? (
            !bookingCancellationInProgress ? (
              <IconLabel
                label={"Cancel Booking"}
                icon={"fa fa-times"}
                onClick={onCancelBooking}
                style={{ cursor: "pointer" }}
                iconContainer={{ width: 28, height: 28 }}
                labelStyle={{
                  fontSize: "0.8rem",
                  color: COLORS.TEXT_COLOR_SECONDARY,
                }}
                iconStyle={{
                  color: COLORS.STATUS_COLORS.FAILURE,
                }}
              />
            ) : (
              <Loader style={{ width: 16, height: 16 }} />
            )
          ) : null}
        </div>

        {showEmailSelection ? (
          <div
            className="modal fade show bd-example-modal-sm"
            id="selectCity"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="selectCity"
            aria-hidden="true"
            style={{ display: "block" }}
          >
            <div
              className="modal-dialog modal-sm"
              role="document"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className="modal-content"
                style={{ background: "#fff", maxWidth: 320 }}
              >
                <div className="modal-body" style={{ padding: 15 }}>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={hideEmailClientSelection}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <p className="bold mb-2">Select Calender</p>

                  <div
                    className="d-flex align-items-center"
                    onClick={onGoogleCalendarClick}
                  >
                    <img
                      src="https://assets.gofloaters.com/icons/google-calendar.png"
                      alt="google-calendar"
                      style={{ width: 40, height: 40 }}
                    />
                    <p className="bold ml-2" style={{ fontSize: "0.9rem" }}>
                      Google
                    </p>
                  </div>
                  <hr style={{ margin: 0 }} />
                  <div
                    className="d-flex align-items-center"
                    onClick={onOutlookCalendarClick}
                  >
                    <img
                      src="https://assets.gofloaters.com/icons/microsoft-outlook.png"
                      alt="outlook"
                      style={{ width: 40, height: 40 }}
                    />
                    <p className="bold ml-2" style={{ fontSize: "0.9rem" }}>
                      Outlook
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <RateExperience
          showRateExperience={showRateExperience}
          hideRateExperienceModal={hideRateExperienceModal}
          bookingkey={bookingkey}
          customerName={customerName}
          spaceName={spaceName}
          spaceId={spaceId}
        />
      </div>
    </div>
  )
}

export default BookingCard
